document.addEventListener('DOMContentLoaded', function() {
    const mobileMenu = {
        mobileMenuElement: document.querySelector('#mega-menu-wrap-main_menu .mega-menu-toggle'),
        leftToggle: null,
        middleToggle: null,
        rightToggle: null,
    }

    if (!mobileMenu.mobileMenuElement) {
        return;
    }

    mobileMenu.leftToggle = mobileMenu.mobileMenuElement.querySelector('.mega-toggle-blocks-left');
    mobileMenu.middleToggle = mobileMenu.mobileMenuElement.querySelector('.mega-toggle-blocks-center');
    mobileMenu.rightToggle = mobileMenu.mobileMenuElement.querySelector('.mega-toggle-blocks-right');

    if (mobileMenu.leftToggle) {
        let template = document.querySelector('#mobileLogoTemplate');
        template = template.content.cloneNode(true);;
        mobileMenu.leftToggle.appendChild(template);
    }

    if (mobileMenu.rightToggle) {
        let template = document.querySelector('#searchForm');
        template = template.content.cloneNode(true);
        mobileMenu.rightToggle.insertBefore(template, mobileMenu.rightToggle.querySelector('.mega-toggle-block'));
    }

    /*
    Trick max mega menu plugin into thinking all viewports below 1024px wide are touch enabled.
    */
    if (window.innerWidth < 1024) {
        const mobileNavToggleButton = document.querySelector('.mega-toggle-block > button');
        if (mobileNavToggleButton) {
            const mobileNavToggleButtonClickHandler = () => {
                jQuery('.mega-menu-link').trigger('touchend.megamenu');
                mobileNavToggleButton.removeEventListener('click', mobileNavToggleButtonClickHandler);
            }
            mobileNavToggleButton.addEventListener('click', mobileNavToggleButtonClickHandler);

        }
    }

});
